import React from "react";

// components

import CardProfile from "components/Cards/CardProfile.js";

export default function Settings() {
  return (
    <>
      <div className="flex flex-wrap">
    {/*    <div className="w-full lg:w-8/12 px-4">
          <CardSettings />
        </div> */}
        <div className="w-full lg:w-8/12 px-8 md:px-4">
          <CardProfile />
        </div>
      </div>
    </>
  );
}
